import { Box, Typography } from '@mui/material';

export const PrimaryBadge = ({ children, sx = [] }: any) => (
  <Box
    sx={[{
      backgroundColor: 'primary.light',
      display: 'inline-block',
      py: '16.5px',
      px: '14px',
      borderRadius: '6px',
    },
    ...(Array.isArray(sx) ? sx : [sx]),
    ]}
  >
    <Typography variant="body2" sx={{ color: 'primary.main', lineHeight: 0 }}>
      {children}
    </Typography>
  </Box>
);

export const SecondaryBadge = ({ children, sx = [], icon }: any) => (
  <Box
    sx={[{
      backgroundColor: 'secondary.light',
      color: 'secondary.dark',
      display: 'inline-block',
      py: '16.5px',
      px: '14px',
      borderRadius: '6px',
    },
    ...(Array.isArray(sx) ? sx : [sx]),
    ]}
  >
    <div className="d-flex align-items-center">
      {icon && icon}
      <Typography variant="body2" sx={{ color: 'secondary.dark', lineHeight: 0 }}>
        {children}
      </Typography>
    </div>
  </Box>
);

export const ErrorBadge = ({ children, sx = [], icon }: any) => (
  <Box
    sx={[{
      backgroundColor: '#f4ebe9',
      display: 'inline-block',
      py: '13px',
      px: '14px',
      borderRadius: '6px',
    },
    ...(Array.isArray(sx) ? sx : [sx]),
    ]}
  >
    <div className="d-flex align-items-center">
      {icon && icon}
      <Typography variant="body2" sx={{ color: '#9a2f2f', lineHeight: 0 }}>
        {children}
      </Typography>
    </div>
  </Box>
);
